import styled from 'styled-components'
import { getProcessFlowDividerStyles } from '../style'
import { ProcessFlowDividerProps } from '../types'

/**
 * A styled divider component for process flow visualization.
 * Supports vertical and horizontal orientations, current/upcoming/completed states.
 *
 * Note: The theme is automatically injected by styled-components.
 * It comes from the ThemeProvider higher up in the component tree
 * and doesn't need to be explicitly imported or passed as a prop.
 */
const StyledProcessFlowDivider = styled.div.withConfig({
    shouldForwardProp: (prop) =>
        !['status', 'direction', 'size', 'color'].includes(prop)
})<ProcessFlowDividerProps>(
    ({
        theme,
        status = 'UPCOMING',
        direction = 'vertical',
        size = 'md',
        color
    }) => getProcessFlowDividerStyles({ theme, status, direction, size, color })
)

export default StyledProcessFlowDivider
